import { render, staticRenderFns } from "./editAssetType.vue?vue&type=template&id=dd6cfea6&scoped=true"
import script from "./editAssetType.vue?vue&type=script&lang=js"
export * from "./editAssetType.vue?vue&type=script&lang=js"
import style0 from "./editAssetType.vue?vue&type=style&index=0&id=dd6cfea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6cfea6",
  null
  
)

export default component.exports